export const ORDER_TABLE_ROWS_PER_PAGE_OPTIONS = [50, 100, 200];
